import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";

export default {
  props: {
    itemData: Object,
  },

  data() {
    return {
      name: "",
      location: "",
      description: "",
      color: "",
      isprivate: null,
      mySpace: 0,
      sort: "",
      target: 0,
      company: this.$store.state.company,
      user: this.$store.state.user,
    };
  },
  watch: {
    name() {
      this.name = this.name.replace("/", "_");
      this.name = this.name.replace("/", "_");
      this.name = this.name.replace(":", "_");
      this.name = this.name.replace("*", "_");
      this.name = this.name.replace("?", "_");
      this.name = this.name.replace("<", "_");
      this.name = this.name.replace(">", "_");
      this.name = this.name.replace("|", "_");
    },
  },
  created() {
    this.target = this.itemData.id;
    this.sort = this.itemData.name;
    this.name = "";
    this.location = "";
    this.description = this.itemData.description;
    this.color = this.itemData.color;
    this.isprivate = this.itemData.private;
    this.mySpace = this.itemData.myspace;

    this.$nextTick(() => {
      //this.$refs.name.focus();
    });
  },
  methods: {
    isValidUrl: function () {
      let url;
      let _url;
      _url = this.location;

      try {
        if (_url.substring(0, 4) != "http") {
          _url = "https://" + _url;
        }

        url = new URL(_url);
      } catch (_) {
        return false;
      }

      if (!(url.protocol === "http:" || url.protocol === "https:")) {
        return false;
      }

      var pattern =
        /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

      return !!pattern.test(url);
    },
    update() {
      if (this.isValidUrl()) {
        let formData = new FormData();
        let url;
        url = this.location;

        if (url.substring(0, 4) != "http") {
          url = "https://" + url;
        }

        formData.append("name", this.name);
        formData.append("location", url);
        formData.append("folder", this.target);
        formData.append("myspace", this.mySpace);

        this.$axios.post(baseUrl + "/add-link", formData).then((response) => {
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        });
      }
    },
  },
};
